angular.module('app.controllers.myaccount', []).controller('MyAccountController', ['$rootScope', '$scope', '$log', '$modal','$window', function ($rootScope, $scope, $log, $modal,$window) {

  'use strict';

  $log.debug('MyAccountController()');

  $scope.open = function (type) {

    var modalInstance = $modal.open({
      animation: true,
      templateUrl: 'templates/'+type+'.html',
      controller: 'MyAccountModalController',
      size: 'lg',
      resolve: {
      }
    });
  };
   
  $scope.openWindow = function(type) {
        //$window.alert("Hello");
        $window.open(type, '_blank');
    };  

}]);

angular.module('app.controllers.myaccount').controller('MyAccountModalController', function ($scope, $modalInstance) {

  $scope.ok = function () {
    $modalInstance.close();
  };

});



function myAccountSplash() {
  if (typeof(Storage) !== "undefined") {
    if ((localStorage.clickcount !== "undefined") && (localStorage.clickcount == 'True')){
        window.location = "https://myaccount.swgas.com/";
    } else {
      localStorage.clickcount = 'True';
      window.location = "/en/the-new-myaccount";
    }

  } else {
    window.location = "https://myaccount.swgas.com/";
  }
}

function myAccountTest() {
  if (typeof(Storage) !== "undefined") {
    if ((sessionStorage.clickcount !== "undefined") && (sessionStorage.clickcount == 'True')){
        window.location = "https://myaccount.swgas.com/";
    } else {
      sessionStorage.clickcount = 'True';
      window.location = "/en/the-new-myaccount";
    }

  } else {
    window.location = "https://myaccount.swgas.com/";
  }
}





